import { dateFilterModel } from "config/filterModels/dateFilterModel";
import { multipleTerminalFilterModel } from "config/filterModels/multipleTerminalFilterModel";
import { FilterModel } from "model/Filter.model";

export const rewardsFilterConfig: FilterModel[] = [dateFilterModel, multipleTerminalFilterModel];
